import { type ActionType, getType } from 'typesafe-actions';

import { RequestStatus, ResponseFailure } from '../../../../models';
import publicActions from '../actions/actions';
import * as privateActions from '../actions/actions';
import { type MfaPromptState } from '../MfaPromptState';

import INITIAL_STATE from './initialState';

export default (
  // eslint-disable-next-line @typescript-eslint/default-param-last -- conform to reducer signature
  state = INITIAL_STATE,
  action: ActionType<
    typeof publicActions & Omit<typeof privateActions, 'default'>
  >
): MfaPromptState => {
  switch (action.type) {
    case getType(publicActions.verificationRequired):
      return {
        ...state,
        isActive: true,
        onSuccessAction: action.payload.onSuccessAction,
        requestedUrl: action.payload.url,
        requestedMethod: action.payload.method,
        protectedUrlsStatus: RequestStatus.Idle,
      };
    case getType(privateActions.verificationDismissed):
      return {
        ...state,
        isActive: false,
        onSuccessAction: undefined,
      };
    case getType(privateActions.verificationSucceeded):
      return {
        ...state,
        isActive: false,
        onSuccessAction: undefined,
      };
    case getType(privateActions.availableFactorsRequested):
      return {
        ...state,
        availableFactorsStatus: RequestStatus.Pending,
        availableFactors: undefined,
      };
    case getType(privateActions.availableFactorsReceived):
      return {
        ...state,
        availableFactorsStatus: RequestStatus.Idle,
        availableFactors: action.payload,
      };
    case getType(privateActions.availableFactorsNotReceived):
      return {
        ...state,
        availableFactorsStatus: RequestStatus.Idle,
        availableFactors: ResponseFailure.Error,
      };
    case getType(privateActions.protectedUrlsRequested):
      return {
        ...state,
        protectedUrlsStatus: RequestStatus.Pending,
      };
    case getType(privateActions.protectedUrlsReceived):
      return {
        ...state,
        protectedUrls: action.payload,
        protectedUrlsStatus: RequestStatus.Idle,
      };
    case getType(privateActions.protectedUrlsNotReceived):
      return {
        ...state,
        protectedUrlsStatus: RequestStatus.Idle,
        protectedUrls: ResponseFailure.Error,
      };
    default:
      return state;
  }
};
